// ---------------------------------------------
// BASE URL
// ---------------------------------------------
// const baseUrl = "https://www.demobackendportal.nigergames.com";
const baseUrl = "";


// ---------------------------------------------
// ALL API ENDPOINTS
// ---------------------------------------------

// Games


// Subscribe
export const subscribeApi = `${baseUrl}/subscribe-user`;

// Headers / Token
export const getHeadersApi = `${baseUrl}/get-headers`;

// Update Activation Status
export const updateStatusApi = `${baseUrl}/update/activation-logs`;
